import React, { useState, useEffect } from 'react';
import CloseButton from '../../../../sharecomponents/CloseButton';
import { getDate } from '../../../../../utils/DateFunctions';
import Post from '../../../../../utils/Post';
import { activeDialog } from '../../../../../utils/Common';
import VainillaDialog from '../../../../sharecomponents/vanilladialog';
import { id } from 'date-fns/locale';

/**
 * 
 * @param {Object} data Objeto con los datos del registro a editar, si se envia un objeto vcio o no se envia nada se pasa a modo creación
 * @param {Function} close Función para cerrar el componente, si se realiza una operación de creación, edición o eliminación se envia verdadero como argumento, false en caso contrario
 * @returns JSX.Element
 */
const NuevoGradoDia = (p) => {
    const [originalData, setoriginalData] = useState(JSON.parse(JSON.stringify(p.data)));
    const edicion = originalData && Object.keys(originalData).length > 0 ? true : false;
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [data, setdata] = useState({
        fecha: edicion ? originalData.fecha : getDate().substring(0, 10),
        maxTemperatura: edicion ? originalData.maxTemperatura : null,
        minTemperatura: edicion ? originalData.minTemperatura : null,
        evapotranspiracion: edicion ? originalData.evapotranspiracion : null,
        id: edicion ? originalData.id : null,
    });
    const close = p.close ?? (() => { });


    useEffect(() => {
        setoriginalData(JSON.parse(JSON.stringify(p.data)));
        setdata({
            fecha: edicion ? originalData.fecha : getDate().substring(0, 10),
            maxTemperatura: edicion ? originalData.maxTemperatura : 0,
            minTemperatura: edicion ? originalData.minTemperatura : 0,
            evapotranspiracion: edicion ? originalData.evapotranspiracion : 0,
            id: edicion ? originalData.id : null,
        });
    }, [p.data]);

    onchange = (e) => setdata({ ...data, [e.target.name]: e.target.value });

    /**
     * Función para crear o actualizar un registro de temperatura y evapotranspiración, usando la variable data, si esta no tiene id se crea el registro, si lo tiene lo actueliza
     */
    const crearOActualizar = async () => {
        if (!data.fecha) {
            activeDialog(setdialog, `'La fecha es requerida' ${data.fecha}`, 'error', 'Error');
            return;
        }
        let resp = await Post('/api/general/gradosDias/add', { ...data }, 'POST', setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return;
        }
        close(true)
    }

    const confimacionEliminar = () => {
        setdialog({
            tipo: "error",
            show: true,
            title: "CONFIRME PARA CONTINUAR",
            body: "¿Realmente desea eliminar el registro de grado día? el registro se mantendrá oculto de los resultados pero seguira existiendo para futuras referencias",
            respYes: "Si, eliminar",
            respNot: "Cancelar",
            funct: (resp) => { if (resp) eliminarGradoDia(); setdialog({ show: false }) },
            size: 'm'
        });
    }

    const eliminarGradoDia = async () => {
        let resp = await Post('/api/general/gradosDias/delete', { id: data.id }, 'POST', setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return;
        }
        close(true)
    }

    return (
        <div className='vw-100 vh-100 blur-l bg-white5 p-2' style={{ position: "fixed", top: 0, left: 0, zIndex: 10, }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <CloseButton close={() => close(false)} />
                <div className='bw-700 round-s bg-white mt-5 shadow-multi p-2'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='w-100 mt-3 mb-4 text-center h4 text-300'>{edicion ? "Edición" : "Registro"} de temperatura y evapotranspiración</div>
                        <div className='bw-200 mt-2'>
                            <label className='text-bold text-s text-satart ps-2 w-100'>Seleccione la fecha</label>
                            <input type='date' className='form-control form-control-sm round-xxl' name="fecha" value={data.fecha} onChange={onchange} />
                        </div>
                        <div className='bw-200 mt-2'>
                            <label className='text-bold text-s text-satart ps-2 w-100'>Temperatura máxima</label>
                            <input type='number' className='form-control form-control-sm round-xxl' name='maxTemperatura' value={data.maxTemperatura ?? 0} onChange={onchange} />
                        </div>
                        <div className='bw-200 mt-2'>
                            <label className='text-bold text-s text-satart ps-2 w-100'>Temperatura mínima</label>
                            <input type='number' className='form-control form-control-sm round-xxl' name='minTemperatura' value={data.minTemperatura ?? 0} onChange={onchange} />
                        </div>
                        <div className='bw-200 mt-2'>
                            <label className='text-bold text-s text-satart ps-2 w-100'>Evapotranspiración</label>
                            <input type='number' className='form-control form-control-sm round-xxl' step={0.1} name='evapotranspiracion' value={data.evapotranspiracion ?? 0} onChange={onchange} />
                        </div>

                        <div className='w-100 mt-3' />
                        {edicion && <div className='bw-200 mb-1'>
                            <button className='btn btn-sm btn-danger pt-0 pb-0 round-xxl shadow w-100 text-bold'
                                onClick={confimacionEliminar}
                            >Eliminar registro</button>
                        </div>}
                        <div className='w-100 mt-3' />
                        <div className='bw-400 mb-4'>
                            <button className='btn btn-sm btn-warning round-xxl shadow w-100 text-bold'
                                onClick={crearOActualizar}
                            >{edicion ? "Actualizar registro" : "Crear registro"}</button>
                        </div>
                    </div>
                </div>
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </div>
    )
}
export default NuevoGradoDia;